















































import QErrors from "@/common/qErrors.vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "EditOptionComponent",
  components: {
    QErrors,
  },
})
export default class EditOptionComponent extends Vue {
  public name: "EditOptionComponent";

  @Prop({
    type: Object,
    default: {},
  })
  public error;

  @Prop({
    type: Array,
    default: [],
  })
  public optionNames;

  public errors = {};
  public names = [];
  public namesEn = [];
  public namesCn = [];

  public async removeOption(index) {
    this.names.splice(index, 1);
    this.namesEn.splice(index, 1);
    this.namesCn.splice(index, 1);
    this.changeOptionNames();
  }

  public async addOption() {
    this.names.push("");
    this.namesEn.push("");
    this.namesCn.push("");
  }

  public clearError(name) {
    this.errors = { ...this.errors, ...{ [name]: [] } };
  }

  public changeOptionNames() {
    this.$emit("change-names", this.names);
    this.$emit("change-names-en", this.namesEn);
    this.$emit("change-names-cn", this.namesCn);
  }

  @Watch("error")
  public changeError() {
    this.errors = this.error;
  }

  @Watch("optionNames")
  public changeNames() {
    if (this.optionNames[0] !== null) {
      this.names = this.optionNames[0];
    }
    if (this.optionNames[1] !== null) {
      this.namesEn = this.optionNames[1];
    }
    if (this.optionNames[2] !== null) {
      this.namesCn = this.optionNames[2];
    }
  }
}
